import { Component } from '@angular/core';
import { setLicenseKey } from 'wijmo/wijmo';

const setting = require('./appsettings.json');

@Component({
  selector: 'nuportal-app',
  template: require('./app.component.html'),
  styles: [require('./app.component.css')]
})
export class AppComponent {
  constructor() {
    setLicenseKey(setting["wijmo_dist_key"]);
  }
}
